/* BW redesign: cart drawer + cart page helpers.
   - Fills the REVIEWS.io rating (public API, store bouncewear.com; same cache key as the home score bar)
   - Fills the review slider on the cart page
   - Updates the "x items" counter on the cart page after quantity changes
   The cart behaviour itself stays in cart-script.min.js. */
(function () {
  if (window.__bwxCart) return;
  window.__bwxCart = true;

  var STORE = 'bouncewear.com';
  var STATS_KEY = 'rio_stats_v2_' + STORE;
  var REV_KEY = 'bwx_rio_reviews_v1_' + STORE;
  var MAX_AGE = 6 * 60 * 60 * 1000;
  var statsP = null;
  var revP = null;

  function cacheGet(key) {
    try {
      var c = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (c && Date.now() - c.t < MAX_AGE) return c;
    } catch (e) {}
    return null;
  }
  function cacheSet(key, val) {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function getStats() {
    if (statsP) return statsP;
    var c = cacheGet(STATS_KEY);
    if (c) return (statsP = Promise.resolve(c));
    statsP = fetch('https://api.reviews.io/merchant/latest?store=' + encodeURIComponent(STORE))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.stats) return null;
        var v = { avg: d.stats.average_rating, total: d.stats.total_reviews, word: d.word, t: Date.now() };
        cacheSet(STATS_KEY, v);
        return v;
      })
      .catch(function () { return null; });
    return statsP;
  }

  function decode(s) {
    var d = new DOMParser().parseFromString('<!doctype html><body>' + (s || ''), 'text/html');
    return (d.body.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function getReviews() {
    if (revP) return revP;
    var c = cacheGet(REV_KEY);
    if (c) return (revP = Promise.resolve(c.list));
    revP = fetch('https://api.reviews.io/merchant/reviews?store=' + encodeURIComponent(STORE) + '&per_page=40&page=0')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var list = [];
        ((d && d.reviews) || []).forEach(function (r) {
          var txt = decode(r.comments);
          if (+r.rating < 4 || txt.length < 25) return;
          var rv = r.reviewer || {};
          var first = decode(rv.first_name).replace(/^"+|"+$/g, '');
          var last = decode(rv.last_name);
          var name = /anonymous/i.test(first) ? '' : (first + (last ? ' ' + last.charAt(0) + '.' : '')).trim();
          list.push({ r: +r.rating, txt: txt, name: name });
        });
        list = list.slice(0, 10);
        cacheSet(REV_KEY, { list: list, t: Date.now() });
        return list;
      })
      .catch(function () { return []; });
    return revP;
  }

  function locale() { return document.documentElement.lang || 'en'; }

  function fillRating(el, s) {
    var avg = parseFloat(s.avg);
    var total = parseInt(s.total, 10);
    if (!avg || !total) { el.classList.add('is-off'); return; }
    var score = avg.toLocaleString(locale(), { minimumFractionDigits: 1, maximumFractionDigits: 2 });
    var count = total.toLocaleString(locale());
    var fill = el.querySelector('[data-rio-fill]');
    if (fill) fill.style.width = (avg / 5 * 100) + '%';
    var sc = el.querySelector('[data-rio-score]');
    if (sc) sc.textContent = score + '/5';
    var cn = el.querySelector('[data-rio-count]');
    if (cn) cn.textContent = (el.getAttribute('data-tpl') || '[n]').replace('[n]', count);
    el.setAttribute('aria-label', score + '/5, ' + cn.textContent);
    el.classList.remove('is-wait');
  }

  function stars(n) {
    var s = document.createElement('span');
    s.className = 'bwx-stars';
    s.setAttribute('aria-label', n + '/5');
    var i = document.createElement('i');
    i.style.width = (n / 5 * 100) + '%';
    s.appendChild(i);
    return s;
  }

  function fillSlider(el) {
    var track = el.querySelector('[data-rio-track]');
    if (!track || track.childElementCount) return;
    getReviews().then(function (list) {
      if (!list || !list.length || track.childElementCount) return;
      var ver = el.getAttribute('data-verified') || '';
      list.forEach(function (rv) {
        var card = document.createElement('div');
        card.className = 'bwx-rv__card';
        card.appendChild(stars(rv.r));
        var p = document.createElement('p');
        p.className = 'bwx-rv__txt';
        p.textContent = rv.txt;
        card.appendChild(p);
        var by = document.createElement('span');
        by.className = 'bwx-rv__by';
        by.textContent = rv.name ? rv.name + ' · ' + ver : ver;
        card.appendChild(by);
        track.appendChild(card);
      });
      var nav = el.querySelector('.bwx-rv__nav');
      if (nav && list.length > 1) {
        nav.hidden = false;
        var step = function (dir) {
          var c = track.querySelector('.bwx-rv__card');
          var w = c ? c.getBoundingClientRect().width + 10 : track.clientWidth;
          track.scrollBy({ left: dir * w, behavior: 'smooth' });
        };
        el.querySelector('[data-rio-prev]').addEventListener('click', function () { step(-1); });
        el.querySelector('[data-rio-next]').addEventListener('click', function () { step(1); });
      }
    });
  }

  function fillAll() {
    var els = document.querySelectorAll('[data-bwx-rio]:not([data-rio-done])');
    if (!els.length) return;
    getStats().then(function (s) {
      els.forEach(function (el) {
        el.setAttribute('data-rio-done', '');
        if (!s) { el.classList.add('is-off'); return; }
        fillRating(el, s);
        if (el.hasAttribute('data-bwx-rio-slider')) fillSlider(el);
      });
    });
  }

  function updateCount() {
    var els = document.querySelectorAll('[data-bwx-cart-count]');
    if (!els.length) return;
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        els.forEach(function (el) {
          var n = c.item_count || 0;
          el.textContent = n === 0 ? '' : n === 1 ? el.getAttribute('data-one') : (el.getAttribute('data-other') || '').replace('[n]', n);
        });
      })
      .catch(function () {});
  }

  function init() {
    fillAll();
    // The drawer inner HTML is replaced after every cart change: re-fill the rating.
    var drawer = document.getElementById('cart-drawer');
    if (drawer && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(fillAll, 50);
      }).observe(drawer, { childList: true, subtree: true });
    }
    if (window.WhatSub && window.WhatSub.subscribe) {
      window.WhatSub.subscribe('CART_UPDATE', function () { fillAll(); updateCount(); });
    }
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', fillAll);
})();
